declare var window: any;
export const env = {
  useCoa: window?.App?.useCoa,
};
